const merchantDev = [
  {
    path: '/merchants/dashboard',
    label_key: 'dashboard',
    icon: 'icon-dashboard',
    order: 0
  },
  {
    path: '/merchants/pos',
    label_key: 'pos_devices',
    icon: 'icon-pos',
    order: 9
  },
  {
    path: '/merchants/help',
    label_key: 'help',
    icon: 'icon-assistance',
    order: 1
  }
]

const merchantMarketer = [...merchantDev]

const merchantAccountant = [
  ...merchantMarketer,
  {
    path: '/merchants/payments',
    label_key: 'payments',
    icon: 'icon-payment_list',
    order: 1
  },
  {
    path: '/merchants/donations',
    label_key: 'donations',
    icon: 'icon-causes',
    order: 1
  },
  {
    path: '/merchants/npos',
    label_key: 'npos',
    icon: 'icon-clients',
    order: 1
  }
  // {
  //   path: '/merchants/fees',
  //   label_key: 'fees',
  //   icon: 'icon-fee',
  //   order: 1
  // }
]

const npoPr = [
  {
    path: '/npos/dashboard',
    label_key: 'dashboard',
    icon: 'icon-dashboard',
    order: 0
  },
  {
    path: '/npos/merchants',
    label_key: 'ref_merchants',
    icon: 'icon-shop',
    order: 1
  },
  {
    path: '/npos/donations',
    label_key: 'donations',
    icon: 'icon-causes',
    order: 1
  },
  {
    path: '/npos/help',
    label_key: 'help',
    icon: 'icon-assistance',
    order: 1
  }
]

export default {
  user: [{}],
  'merchant-dev': merchantDev,
  'merchant-marketer': merchantMarketer,
  'merchant-accountant': merchantAccountant,
  'merchant-admin': merchantAccountant,
  'npo-admin': npoPr,
  'npo-pr': npoPr
}



// WEBPACK FOOTER //
// ./src/config/navigation.js